import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {
  GeneralCardElements,
  OrderedCardsList,
  User,
  LearningArea,
  LearningSession,
  CourseModel,
  CourseModelProps,
  CourseBase,
  CardsList,
  AlertInformation,
} from "@/types";
import { IonGrid, IonRow, IonCol, IonAlert, IonModal } from "@ionic/vue";
import { reactive, Ref, ref, watch } from "vue";
import { useStore } from "vuex";
import {
  executeLink,
  getCurrentElement,
  getCurrentLanguage,
  getCustomMessage,
  getLearningContexts,
  getIcon,
  setupError,
  downloadCsv,
} from "@/utils";
import { useRoute } from "vue-router";

type Indexes = {
  group: string;
  index: number;
};

type AvailableModal = "course_details" | "success" | "error";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectClassSelectList',
  async setup(__props) {

let __temp: any, __restore: any

const is_nothing_selected = () =>
  selected_element_indexes.group == "-1" &&
  selected_element_indexes.index == -1;
const find_element = (
  list: OrderedCardsList<GeneralCardElements>,
  id?: string
): Indexes => {
  const groups = Object.keys(list.cards);

  let count = 0;
  let year: string;
  let index: number;

  do {
    year = groups[count];
    index = list.cards[year].findIndex((a: GeneralCardElements) => {
      if (id != undefined) {
        return a.id == id;
      } else {
        return a.selected;
      }
    });
    count++;
  } while (index == -1 && count < groups.length);

  return {
    group: year,
    index: index,
  };
};
const changeSelection = async () => {
  let group_changed: boolean;

  if (
    selected_element_indexes.group != "-1" &&
    selected_element_indexes.index != -1
  ) {
    selectedChange(learning_sessions_cards);
  }

  const tmp_selected = find_element(
    learning_sessions_cards,
    store.state.event.data.id
  );
  if (
    selected_element_indexes.group == tmp_selected.group &&
    selected_element_indexes.index == tmp_selected.index
  ) {
    selected_element_indexes = {
      group: "-1",
      index: -1,
    };
    if (selected_option.value == "open_day_courses") {
      courses.order = [];
      courses.cards = {};
      options = [];
      selected_option.value = "";
    } else {
      propositions.order = [
        {
          key: "to_approve",
          title: getCustomMessage(
            "to_approve",
            getCurrentElement("to_approve"),
            "title"
          ),
        },
        {
          key: "approved",
          title: getCustomMessage(
            "approved",
            getCurrentElement("approved"),
            "title"
          ),
        },
      ];
      propositions.cards = {
        to_approve: [],
        approved: [],
      };
      selected_option.value = "project_classes";
    }
  } else {
    group_changed = selected_element_indexes.group != tmp_selected.group;
    selected_element_indexes = tmp_selected;
    learning_session_id =
      learning_sessions_cards.cards[selected_element_indexes.group][
        selected_element_indexes.index
      ].id;
    if ($route.name == "open_day_courses") {
      options = (await getLearningContexts(user, learning_session_id)).map(
        (a) => {
          return {
            id: a.id,
            title: a[`${language}_title`],
          };
        }
      );
      selected_option.value = options.length > 0 ? options[0].id : "";
      tmp_card_list = await getCourses();
      courses.cards = tmp_card_list.cards;
      courses.order = tmp_card_list.order;
      selectedChange(learning_sessions_cards);
    } else {
      if (selected_option.value != "courses" || group_changed) {
        propositions.order = [
          {
            key: "to_approve",
            title: getCustomMessage(
              "to_approve",
              getCurrentElement("to_approve"),
              "title"
            ),
          },
          {
            key: "approved",
            title: getCustomMessage(
              "approved",
              getCurrentElement("approved"),
              "title"
            ),
          },
        ];
        propositions.cards = await getPropositions();
        selectedChange(learning_sessions_cards);
      }
    }
  }
};
const selectedChange = (
  list: OrderedCardsList<GeneralCardElements>,
  group = selected_element_indexes.group,
  index = selected_element_indexes.index,
  value = !learning_sessions_cards.cards[group][index].selected
) => {
  list.cards[group][index].selected = value;
  trigger.value++;
};
const getPropositions = async () => {
  const session_propositions: CourseModel[] = await (selected_option.value ==
  "project_classes"
    ? executeLink(
        "/v1/propositions?recent_models=false&session_id=" +
          learning_session_id,
        async (response: any) =>
          Promise.all(
            response.data.data.map(async (a: CourseModelProps) => {
              const tmp_proposition = new CourseModel(
                a,
                learning_sessions.find((b) => b.id == a.learning_session_id)
              );
              //await tmp_proposition.loadParms()
              return tmp_proposition;
            })
          ),
        () => []
      )
    : executeLink(
        "/v1/propositions?recent_models=false&session_id=" +
          learning_session_id +
          "&school_year=" +
          selected_element_indexes.group,
        (response: any) =>
          response.data.data.map((a: CourseModelProps) => new CourseModel(a)),
        () => []
      ));

  const cards: CardsList<GeneralCardElements> = {
    approved: [],
    to_approve: [],
  };

  for (const proposition of session_propositions) {
    if (selected_option.value == "project_classes") {
      if (
        proposition.creation_school_year ==
          parseInt(selected_element_indexes.group) &&
        "" + proposition.learning_session?.id == learning_session_id
      ) {
        cards[proposition.isApproved() ? "approved" : "to_approve"].push(
          proposition.toCard(user, true)
        );
      }
    } else {
      if (
        proposition.creation_school_year ==
        parseInt(selected_element_indexes.group)
      ) {
        cards[proposition.isApproved() ? "approved" : "to_approve"].push(
          proposition.toCard(user, true)
        );
      }
    }
  }

  return cards;
};
const getCourses = async () => {
  const tutor_courses: CourseBase[] = await executeLink(
    "/v1/teachers/" +
      user.id +
      "/tutor_courses?session_id=" +
      learning_session_id +
      "&context_id=" +
      selected_option.value,
    (response: any) => response.data.data.map((a: any) => new CourseBase(a)),
    () => []
  );

  const ordered_cards: OrderedCardsList<GeneralCardElements> = {
    order: [],
    cards: {},
  };

  let tmp_area: LearningArea | undefined;

  for (const course of tutor_courses) {
    if (ordered_cards.cards[course.learning_area_id] == undefined) {
      tmp_area = learning_areas.find((a) => a.id == course.learning_area_id);
      ordered_cards.cards[course.learning_area_id] = [];
      ordered_cards.order.push({
        key: course.learning_area_id,
        title: getCustomMessage(
          "title",
          tmp_area != undefined
            ? tmp_area[`${language}_title`]
            : course.learning_area_id,
          "title"
        ),
      });
    }
    ordered_cards.cards[course.learning_area_id].push(course.toCard());
  }

  return ordered_cards;
};
const setupModalAndOpen = (window?: AvailableModal, message?: string) => {
  const actual_window: AvailableModal = window ?? store.state.event.event;
  const actual_message: string = message ?? store.state.event.data?.message;

  switch (actual_window) {
    case "course_details":
      description_title = store.state.event.data.title;
      description_course_id = store.state.event.data.course_id;
      description_open.value = true;
      break;
    case "success":
      alert_information.title = "";
      alert_information.message =
        message ?? getCurrentElement(getCurrentElement("successful_operation"));
      alert_information.buttons = [getCurrentElement("ok")];
      alert_open.value = true;
      break;
    case "error":
      setupError(actual_message);
      alert_open.value = true;
      break;
  }
};
const closeModal = (window: AvailableModal) => {
  switch (window) {
    case "course_details":
      description_open.value = false;
      break;
    case "success":
    case "error":
      alert_open.value = false;
      break;
  }
};
const exportPropositions = () => {
  executeLink(
    undefined,
    (response) =>
      downloadCsv(response.data, "propositions.csv").then((outcom_code) => {
        if (outcom_code == 1) {
          setupModalAndOpen(
            "success",
            getCurrentElement("propositions_exported")
          );
        } else if (outcom_code == 0) {
          setupModalAndOpen(
            "success",
            getCurrentElement("no_propositions") +
              ". " +
              getCurrentElement("no_file_exported")
          );
        } else {
          setupModalAndOpen("error");
        }
      }),
    () => setupModalAndOpen("error")
  );
};

const store = useStore();
const user = User.getLoggedUser() as User;
const $route = useRoute();
const alert_information: AlertInformation = store.state.alert_information;
const language = getCurrentLanguage();

const promises: Promise<any>[] = [];
const learning_sessions_cards: OrderedCardsList<GeneralCardElements> = reactive(
  {
    order: [],
    cards: {},
  }
);
const propositions: OrderedCardsList<GeneralCardElements> = reactive({
  order: [],
  cards: {},
});
const courses: OrderedCardsList<GeneralCardElements> = reactive({
  order: [],
  cards: {},
});
const school_years: number[] =
  $route.name == "open_day_courses"
    ? (
        (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
          "/v1/teachers/" + user.id + "/tutor_years",
          (response: any) => response.data.data.map((a: any) => a.school_year),
          () => []
        ))),
  __temp = await __temp,
  __restore(),
  __temp
)
      ).reverse()
    : user.type == "teacher"
    ? (
        (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
          "/v1/teachers/" + user.id + "/active_years",
          (response: any) => response.data.data.map((a: any) => a.year),
          () => []
        ))),
  __temp = await __temp,
  __restore(),
  __temp
)
      ).reverse()
    : (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
        "/v1/ordinary_classes?descending=true",
        (response: any) => [
          ...new Set(response.data.data.map((a: any) => a.school_year)),
        ],
        () => []
      ))),
  __temp = await __temp,
  __restore(),
  __temp
);

const learning_areas: LearningArea[] = (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
  "/v1/learning_areas",
  (response: any) => response.data.data,
  () => []
))),
  __temp = await __temp,
  __restore(),
  __temp
);
const learning_sessions: LearningSession[] = []; /* await executeLink(
      "/v1/learning_sessions?school_year=" + year,
      async (response) => {
        learning_sessions_cards.order.push({
          key: year,
          title: getCustomMessage("title", year, "title"),
        });
        learning_sessions_cards.cards[year] = [];
        for (const learning_session of response.data.data) {
          learning_sessions_cards.cards[year].push(
            await new LearningSession(learning_session).toCard(false)
          );
        }
      }
    )*/
const trigger = ref(0);
const selected_option: Ref<string> = ref(
  $route.name == "open_day_courses" ? "" : "project_classes"
);
const alert_open = ref(false);
const description_open = ref(false);
const buttons = [
  {
    id: "export",
    type: "string_icon",
    linkType: "request",
    content: {
      text: getCurrentElement("export"),
      icon: getIcon("download"),
      url: "/v1/propositions/export",
      method: "get",
      whole_link: true,
    },
    ...store.state.button_css,
  },
];

let tmp_card_list: OrderedCardsList<GeneralCardElements>,
  description_title: string,
  description_course_id: number;
let options: {
  id: string;
  title?: string;
}[] =
  $route.name == "open_day_courses"
    ? []
    : [
        {
          id: "project_classes",
          title: getCurrentElement("project_classes_propositions"),
        },
        {
          id: "courses",
          title: getCurrentElement("courses_propositions_per_year"),
        },
      ];
let selected_element_indexes: Indexes = reactive({
  group: "-1",
  index: -1,
});
let learning_session_id = "-1";

for (const year of school_years) {
  promises.push(
    executeLink(
      "/v1/learning_sessions?school_year=" + year,
      async (response) => {
        learning_sessions_cards.order.push({
          key: year,
          title: getCustomMessage("title", year, "title"),
        });
        learning_sessions_cards.cards[year] = [];
        for (const learning_session of response.data.data) {
          learning_sessions.push(new LearningSession(learning_session));
          learning_sessions_cards.cards[year].push(
            await new LearningSession(learning_session).toCard(false)
          );
        }
      }
    )
  );
}
;(
  ([__temp,__restore] = _withAsyncContext(() => Promise.all(promises))),
  await __temp,
  __restore()
);

watch(selected_option, async (new_option) => {
  if (new_option != undefined && new_option != "") {
    if (
      selected_element_indexes.group != "-1" &&
      selected_element_indexes.index != -1
    ) {
      if ($route.name == "open_day_courses") {
        tmp_card_list = await getCourses();
        courses.cards = tmp_card_list.cards;
        courses.order = tmp_card_list.order;
      } else {
        propositions.cards = await getPropositions();
      }
    }
  }
  trigger.value++;
});

return (_ctx: any,_cache: any) => {
  const _component_course_description = _resolveComponent("course-description")!
  const _component_loading_component = _resolveComponent("loading-component")!
  const _component_ionic_element = _resolveComponent("ionic-element")!
  const _component_list_card = _resolveComponent("list-card")!
  const _component_custom_select = _resolveComponent("custom-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonAlert), {
      "is-open": alert_open.value,
      header: _unref(alert_information).title,
      message: _unref(alert_information).message,
      buttons: _unref(alert_information).buttons,
      onDidDismiss: _cache[0] || (_cache[0] = ($event: any) => (closeModal('success')))
    }, null, 8, ["is-open", "header", "message", "buttons"]),
    _createVNode(_unref(IonModal), {
      "is-open": description_open.value,
      onDidDismiss: _cache[2] || (_cache[2] = ($event: any) => (closeModal('course_details')))
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_Suspense, null, {
          default: _withCtx(() => [
            _createVNode(_component_course_description, {
              title: _unref(description_title),
              course_id: _unref(description_course_id),
              learning_session_id: _unref(learning_session_id),
              onClose: _cache[1] || (_cache[1] = ($event: any) => (closeModal('course_details')))
            }, null, 8, ["title", "course_id", "learning_session_id"])
          ]),
          fallback: _withCtx(() => [
            _createVNode(_component_loading_component)
          ]),
          _: 1
        }))
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createVNode(_unref(IonGrid), null, {
      default: _withCtx(() => [
        (_unref($route).name != 'open_day_courses')
          ? (_openBlock(), _createBlock(_unref(IonRow), { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ionic_element, {
                      element: 
            _unref(getCustomMessage)(
              'export_description',
              _unref(getCurrentElement)('non_confirmed_export') + ':',
              'string',
              undefined,
              {
                label: {
                  'ion-padding': true,
                },
              }
            )
          
                    }, null, 8, ["element"]),
                    _createVNode(_component_ionic_element, {
                      element: buttons[0],
                      onExecute_link: exportPropositions
                    }, null, 8, ["element"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_unref(IonRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), {
              size: "12",
              "size-md": "6"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_list_card, {
                  title: 
            _unref(getCustomMessage)('title', _unref(getCurrentElement)('learning_sessions'))
          ,
                  emptiness_message: 
            _unref(getCustomMessage)(
              'emptiness_message',
              _unref(getCurrentElement)('no_sessions')
            )
          ,
                  cards_list: learning_sessions_cards,
                  colors: {
            hover: {
              name: 'light',
              alpha: 0.14,
              type: 'var',
            },
            list_borders: {
              name: 'black',
              type: 'var',
              alpha: 0.25,
            },
          },
                  onSignal_event: _cache[3] || (_cache[3] = ($event: any) => (changeSelection()))
                }, null, 8, ["title", "emptiness_message", "cards_list", "colors"])
              ]),
              _: 1
            }),
            _createVNode(_unref(IonCol), {
              size: "12",
              "size-md": "6"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_custom_select, {
                  selected_option: selected_option.value,
                  "onUpdate:selected_option": _cache[4] || (_cache[4] = ($event: any) => ((selected_option).value = $event)),
                  list: _unref(options),
                  label: 
            _unref(getCurrentElement)(
              _unref($route).name == 'open_day_courses'
                ? 'learning_contexts'
                : 'propositions'
            ) + ':'
          ,
                  aria_label: 
            _unref(getCurrentElement)(
              _unref($route).name == 'open_day_courses' ? 'courses' : 'propositions'
            )
          ,
                  placeholder: 
            _unref(getCurrentElement)(
              is_nothing_selected()
                ? _unref($route).name == 'open_day_courses'
                  ? 'learning_context_choice'
                  : 'propositions_type_choice'
                : _unref($route).name == 'open_day_courses'
                ? 'no_learning_contexts'
                : 'no_types_propositions'
            )
          ,
                  getCompleteName: (option) => option.title
                }, null, 8, ["selected_option", "list", "label", "aria_label", "placeholder", "getCompleteName"]),
                (_openBlock(), _createBlock(_component_list_card, {
                  key: trigger.value,
                  emptiness_message: 
            _unref(getCustomMessage)(
              'emptiness_message',
              _unref(getCurrentElement)(
                is_nothing_selected()
                  ? selected_option.value == 'project_classes'
                    ? 'project_classes_propositions_selection_message'
                    : _unref($route).name == 'open_day_courses'
                    ? 'courses_selection_message'
                    : 'courses_propositions_selection_message'
                  : _unref($route).name == 'open_day_courses'
                  ? 'no_courses'
                  : 'no_propositions'
              )
            )
          ,
                  cards_list: 
            _unref($route).name == 'open_day_courses' ? courses : propositions
          ,
                  colors: {
            hover: {
              name: 'light',
              alpha: 0.14,
              type: 'var',
            },
            list_borders: {
              name: 'black',
              type: 'var',
              alpha: 0.25,
            },
          },
                  onSignal_event: _cache[5] || (_cache[5] = ($event: any) => (setupModalAndOpen()))
                }, null, 8, ["emptiness_message", "cards_list", "colors"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})